import { uuid } from "vue-uuid";

export default {
  get() {
    return uuid.v4();
  },
};
